import React from 'react';
import { AppConfig } from '../AppConfig';

class FooterDiv extends React.Component {
  render() {
    const communitySite = AppConfig.community != null;
    return (
      <div style={{marginTop: 'auto', padding: '20px 10px 10px 10px', textAlign: 'center', fontSize: '0.95em', lineHeight: '1.5'}}>
        {!communitySite && 
        <div>© 2025, Monster Ideas LLC.  All rights reserved.</div>
        }
        {communitySite && 
          <div>
            Powered by <a href="https://www.oneclick.community" style={{color: 'var(--body-color)'}}>OneClick Community</a>.
            Make your own today!
          </div>
        }
      </div>
    );
  }
}

export default FooterDiv;
